import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ValueEncoder } from "../Utils/ValueEncoder";
import { Reason } from "../Export/AssetPandaExport";

export class JiraExport implements ObjectSerializer {

	public EnableExport: boolean;

	public TargetServerURL: string;
	public TargetServerUsername: string;
	public TargetApiToken: string;
	public TargetObjectSchema: string;

	public ExportOrigin: string;

	public ExportDevices: boolean;

	public get HasTargetServerURL(): boolean {
		return !!this.TargetServerURL;
	}

	public get HasTargetServerUsername(): boolean {
		return !!this.TargetServerUsername;
	}

	public get HasTargetApiToken(): boolean {
		return !!this.TargetApiToken;
	}

	public get HasTargetObjectSchema(): boolean {
		return !!this.TargetObjectSchema;
	}

	public get HasExportOrigin(): boolean {
		return !!this.ExportOrigin;
	}

	constructor() {
		this.Clear();
	}

	public Copy(other: JiraExport): void {
		this.Clear();

		this.EnableExport = other.EnableExport;

		this.TargetServerURL = other.TargetServerURL;
		this.TargetServerUsername = other.TargetServerUsername;
		this.TargetApiToken = other.TargetApiToken;
		this.TargetObjectSchema = other.TargetObjectSchema;

		this.ExportOrigin = other.ExportOrigin;

		this.ExportDevices = other.ExportDevices;
	}

	public Clear(): void {
		this.EnableExport = false;

		this.TargetServerURL = "";
		this.TargetServerUsername = "";
		this.TargetApiToken = "";
		this.TargetObjectSchema = "";

		this.ExportOrigin = "agent";

		this.ExportDevices = false;
	}

	public Equals(obj: any): boolean {
		if (!obj)
			return false;

		if (!(obj instanceof JiraExport))
			return false;
		var other = (obj as JiraExport);

		return (
			this.EnableExport == other.EnableExport &&

			this.TargetServerURL == other.TargetServerURL &&
			this.TargetServerUsername == other.TargetServerUsername &&
			this.TargetApiToken == other.TargetApiToken &&
			this.TargetObjectSchema == other.TargetObjectSchema &&

			this.ExportOrigin == other.ExportOrigin &&

			this.ExportDevices == other.ExportDevices);
	}

	public IsValid(reason: Reason): boolean {
		reason.Value = "";

		if (this.EnableExport) {
			if (!this.HasTargetServerURL) {
				reason.Value = "The Jira URL must be specified";
				return false;
			}
			if (!this.HasTargetServerUsername) {
				reason.Value = "The Jira API username must be specified";
				return false;
			}
			if (!this.HasTargetApiToken) {
				reason.Value = "The Jira API password must be specified";
				return false;
			}
			if (!this.HasTargetObjectSchema) {
				reason.Value = "The Jira object schema must be specified";
				return false;
			}

			return true;
		}
		else {
			return true;
		}
	}

	public Write(obj: any, context: any): void {
		obj.jira_export = {};
		obj = obj.jira_export;

		obj.enable_export = ValueEncoder.EncodeBoolean(this.EnableExport);

		if (this.HasTargetServerURL)
			obj.target_server_url = this.TargetServerURL;
		if (this.HasTargetServerUsername)
			obj.target_server_username = this.TargetServerUsername;
		if (this.HasTargetApiToken)
			obj.target_server_api_key = this.TargetApiToken;
		if (this.HasTargetObjectSchema)
			obj.schema_name = this.TargetObjectSchema;

		if (this.HasExportOrigin)
			obj.export_origin = this.ExportOrigin;

		obj.export_devices = ValueEncoder.EncodeBoolean(this.ExportDevices);
	}

	public Read(obj: any, context: any): void {
		this.Clear();

		if (!obj.jira_export)
			throw new Error();
		obj = obj.jira_export;

		if (obj.enable_export !== undefined)
			this.EnableExport = ValueEncoder.DecodeBoolean(obj.enable_export);

		if (obj.target_server_url !== undefined)
			this.TargetServerURL = obj.target_server_url;
		if (obj.target_server_username !== undefined)
			this.TargetServerUsername = obj.target_server_username;
		if (obj.target_server_api_key !== undefined)
			this.TargetApiToken = obj.target_server_api_key;
		if (obj.schema_name !== undefined)
			this.TargetObjectSchema = obj.schema_name;

		if (obj.export_origin !== undefined)
			this.ExportOrigin = obj.export_origin;

		if (obj.export_devices !== undefined)
			this.ExportDevices = ValueEncoder.DecodeBoolean(obj.export_devices);
	}

}